module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/staff-summary/staff-summary.component.css
// module id = ./src/app/web/game/management/business-units/staff-summary/staff-summary.component.css
// module chunks = main